import { render, staticRenderFns } from "./OsElement.vue?vue&type=template&id=42d876b6&scoped=true"
import script from "./OsElement.vue?vue&type=script&lang=js"
export * from "./OsElement.vue?vue&type=script&lang=js"
import style0 from "./OsElement.vue?vue&type=style&index=0&id=42d876b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d876b6",
  null
  
)

export default component.exports